export const BULK_FETCH_CONCURRENCY_LIMIT = 6;

// Cap simultaneous requests so a large id list doesn't burst past the backend's
// per-user rate limit.
export const fetchChunksWithConcurrencyLimit = async <T>(
  chunks: readonly number[][],
  fetchChunk: (chunk: number[]) => Promise<T>,
): Promise<T[]> => {
  const responses: T[] = [];
  for (let i = 0; i < chunks.length; i += BULK_FETCH_CONCURRENCY_LIMIT) {
    const batch = chunks.slice(i, i + BULK_FETCH_CONCURRENCY_LIMIT);
    responses.push(...(await Promise.all(batch.map((chunk) => fetchChunk(chunk)))));
  }
  return responses;
};
